import React from 'react';
import Iframe from 'react-iframe-click';
import videoJS from 'video.js';
import './Video.css';

function isYouTube(url) {
  return url.includes('//www.youtu') || url.includes('//youtu');
}

function isLoom(url) {
  return url.includes('//www.loom.com');
}

export function getYouTubeID(url) {
  if (isYouTube(url)) {
    let id = url.split('/').pop();
    if (id.startsWith('watch')) {
      id = id.split('=')[1];
    }
    if (id.includes('?')) {
      id = id.split('?')[0];
    }
    return id;
  }
  return '';
}

function extractVideoURL(url) {
  if (!url) return false;

  if (isLoom(url)) {
    return url.replace('share', 'embed');
  }

  if (isYouTube(url)) {
    const id = getYouTubeID(url);
    return `https://www.youtube.com/embed/${id}`;
  }
  return url;
}

function isVideoFile(url) {
  const extension = url.split('.').pop().toLowerCase();
  if (['mp4'].includes(extension)) {
    return true;
  }
  return false;
}

const styles = {
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
};

export default function Video({
  video,
  videoStyles,
  onClick,
  autoplay,
  loop,
  muted,
  playsinline,
  poster = '',
  isFeatureBlock = false,
}) {
  const videoURL = extractVideoURL(video);
  if (!videoURL) return <div />;
  if (isVideoFile(videoURL)) {
    return (
      <video
        onClick={onClick}
        className={`video-js vjs-theme-sea vjs-fluid rounded-[22px] !h-[245px] overflow-hidden${
          isFeatureBlock ? ' !border-0' : ''
        }`}
        controls={!(isFeatureBlock && autoplay)}
        preload="auto"
        ref={(el) => {
          if (!el) return;
          if (el._vv) return;
          el._vv = 1;
          videoJS(el);
        }}
        data-setup="{}"
        autoPlay={autoplay}
        loop={loop}
        muted={muted}
        playsInline={playsinline}
        poster={poster}
      >
        <source src={videoURL} type="video/mp4" />
      </video>
    );
  }

  let urlOptions = '';
  if (isYouTube(videoURL)) {
    urlOptions = videoURL?.includes('?') ? '&rel=0&' : '?rel=0&';
    if (autoplay) urlOptions += 'autoplay=1&mute=1&';
    if (playsinline) urlOptions += 'playsinline=1&';
    if (loop) urlOptions += `loop=1&playlist=${getYouTubeID(videoURL)}&`;
  }

  return (
    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
      <Iframe
        onInferredClick={onClick}
        src={videoURL + urlOptions}
        data-managed
        frameBorder={0}
        webkitAllowFullsScreen
        mozAllowFullScreen
        allowFullScreen
        style={{
          borderRadius: '22px',
          overflow: 'hidden',
          ...styles.video,
          ...videoStyles,
        }}
      />
    </div>
  );
}
